module.exports = __webpack_public_path__ + "img/layout-text-sidebar.27e924a1.svg";